import type { ReactNode } from 'react';
import { Button } from '@/components/Button/Button';
import { Modal } from '@/components/Modal/Modal';
import { t } from '@/lib/i18n';
import styles from './ComingSoonModal.module.css';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Big icon glyph rendered inside the preview circle. */
  icon: ReactNode;
  /** Modal heading. Also the dialog's accessible name. */
  title: string;
  /** Prose body explaining what's coming. */
  body: ReactNode;
}

export function ComingSoonModal({ open, onOpenChange, icon, title, body }: Props) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      size="md"
      actions={
        <Button variant="primary" onClick={() => onOpenChange(false)}>
          {t('Got it')}
        </Button>
      }
    >
      <div className={styles.hero}>
        <div className={styles['icon-circle']} aria-hidden>
          {icon}
        </div>
        <p className={styles.eyebrow}>{t('Coming soon')}</p>
      </div>
      <div className={styles.body}>{body}</div>
    </Modal>
  );
}
